import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {BaseComponent} from "./layout/base/base.component";
import {GeolocationComponent} from "./views/geolocation/geolocation.component";
import {IsAuthGuard} from "./core/guard/auth.guard";
import {TokenUnlockComponent} from "./views/token-unlock/token-unlock.component";
import {ResetPasswordComponent} from './components/reset-password/reset-password.component';
import {DashboardComponent} from "./views/dashboard/dashboard.component";
import {loadRemoteModule} from '@angular-architects/module-federation';
import {environment} from "../environments/environment";
import {WelcomeComponent} from './components/welcome/welcome.component';
import {FeedbackComponent} from './components/feedback/feedback.component';
import {FeedbackFormComponent} from './components/feedback-form/feedback-form.component';
import {NpsLogoutComponent} from "./components/nps-logout/nps-logout.component";
import {isLocationAllowed} from "./lib/services/geolocation/localization.guard";
import {ActivateLocationComponent} from "./components/activate-location/activate-location.component";
import {
    ChangeTemporalPasswordComponent
} from "./components/change-temporal-password/change-temporal-password.component";
import {RequireChangePassword} from "./core/guard/temporal-password.guard";
import {DiscoverYourBankComponent} from "./components/discover-your-bank/discover-your-bank.component";

const routes: Routes = [
    {
        path: 'nueva-banca-digital',
        component: BaseComponent,
        canActivate: [RequireChangePassword, isLocationAllowed, IsAuthGuard],
        children: [
            {
                path: 'destinatarios',
                loadChildren: () => loadRemoteModule({
                    type: 'module',
                    remoteEntry: environment.remoteEntryAccountManagement,
                    exposedModule: './AccountManagement'
                }).then((m) => m.ReceiversModule)
            },
            {
                path: 'pagos',
                loadChildren: () => loadRemoteModule({
                    type: 'module',
                    remoteEntry: environment.remoteEntryPayments,
                    exposedModule: './PaymentsModule'
                }).then((m) => m.PaymentsModule)
            },
            /*
            {
             path: "consulta-dinamica",
             component: ConsultaDinamicaComponent

            },
            */
            {

                path: 'forwards/front',
                loadChildren: () => loadRemoteModule({
                    type: 'module',
                    remoteEntry: environment.remoteEntryForwards, //TODO: probar con team de forwards
                    exposedModule: './Module'
                }).then((m) => m.AccountModule)
            },
            {
                path: 'consulta-dinamica',
                loadChildren: () => loadRemoteModule({
                    type: 'module',
                    remoteEntry: environment.remoteEntryConsultaDinamica, //TODO: probar con team de consulta
                    exposedModule: './PagesModule'
                }).then((m) => m.PagesModule)
            },
            {
                path: 'dashboard',
                component: DashboardComponent
            },
            {
                path: '',
                redirectTo: 'dashboard',
                pathMatch: 'full'
            }
        ]
    },
    {
        path: 'login',
        component: GeolocationComponent,
        canActivate: [isLocationAllowed]
    },
    {
        path: 'token-unlock',
        component: TokenUnlockComponent
    },
    {
        path: '',
        redirectTo: 'nueva-banca-digital',
        pathMatch: 'full'
    },
    {
        path: 'reset-password',
        component: ResetPasswordComponent
    },
    {
        path: 'welcome',
        component: WelcomeComponent
    },
    {
        path: 'feedback',
        component: FeedbackComponent
    }
    ,
    {
        path: 'feedback-form',
        component: FeedbackFormComponent
    },
    {
        path: "users",
        loadChildren: () => loadRemoteModule({
            type: 'module',
            remoteEntry: environment.remoteEntryUsers,
            exposedModule: './Users'
        }).then((m) => m.UsersModule)
    },
    {
        path: 'nps',
        canActivate: [IsAuthGuard],
        component: NpsLogoutComponent
    },
    {
        path: 'activateLocation',
        component: ActivateLocationComponent
    },
    {
        path: 'changeTemporalPassword',
        component: ChangeTemporalPasswordComponent
    },
    {
        path: 'nueva-banca-digital/discover-your-bank',
        canActivate: [isLocationAllowed,IsAuthGuard],
        component: DiscoverYourBankComponent
    }

];

@NgModule({
    imports: [RouterModule.forRoot(routes, {useHash: true})],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
